import 'es6-symbol/implement';
import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import _ from 'lodash';
import {hashHistory as history} from 'react-router';
import enUS from 'antd/lib/locale-provider/en_US';
import { LocaleProvider, notification, Modal } from 'antd';
import createStore from 'helpers/createStore'
import {logFatal} from './helpers/logServices';
import {Component as App, reducer, init} from 'modules/app';
import i18next from 'i18next';
import customization from 'customization';
import moment from 'moment';
import socket from 'helpers/esocket';
import clientId from 'clientId';

import './antd-deepblue.css';

const { lang, permission, id, group_id } = JSON.parse(localStorage.me);
const store = createStore(reducer, init(), {history});
let logoutTime;
//浏览器弹框提醒
function timeLogoutNotification(message, des) {
  // 判斷瀏覽器是否支持
  if (!("Notification" in window)) {
    notificationWarning(message, des)
  }
  // 用戶允許瀏覽器彈框
  else if (Notification.permission === "granted") {
    const options = {
      icon: customization.favicon,
      body: des,
      noscreen: true
    }
    var notification = new Notification(
      message,
      options
    );
    setTimeout(notification.close.bind(notification), 60000);
  }
  // 用戶拒絕
  else if (Notification.permission !== "denied") {
    Notification.requestPermission(function (permission) {
      // 重新詢問是否支持
      if (permission === "granted") {
        const options = {
          icon: customization.favicon,
          body: des,
          noscreen: true
        }
        var notification = new Notification({
          message,
          options
        });
        setTimeout(notification.close.bind(notification), 60000); 
      }
    });
  }
}
//antd弹框提醒
const notificationWarning = (message, des) => {
  notification.warning({
    message: message,
    description: des,
    duration: null,
  });
}

document.title = customization.title;
document.head.querySelector("link").href = customization.favicon;
document.onmouseover = () => {
  //鼠标事件监听
  setLocalStoraneTime();
}
document.onkeydown = () => {
  //键盘事件监听
  setLocalStoraneTime();
}

//当用户有操作时，存储用户操作时间
const setLocalStoraneTime = () => {
  if (_.get(permission, 'automaticLogoutTime')) {
    const nowTime = moment().format('x');
    if (!localStorage.time) {
      localStorage.time = nowTime
    } else {
      const time = parseInt(localStorage.time);
      //用户操作时间1分钟更新一次
      if (nowTime - time >= 60000) {
        localStorage.time = nowTime
      }
    }
  }
}

//判断用户是否长时间未操作
const autoLogoutTime = () => {
  const nowTime = moment().format('x');
  if (!localStorage.time) {
    localStorage.time = nowTime
  }
  const time = parseInt(localStorage.time);
  const momentTime = moment(time)
  const nowMoment = moment()
  if (nowTime - time >= 300000 && nowTime - time < 600000 && localStorage.timeLogout !== "5") {
    //5分钟
    const spareTime = _.get(permission, 'automaticLogoutTime') - 5;
    const message = t('unusedMessage', {time: 5});
    const des = t('unusedDescription', {unusedTime: 5, spareTime});
    localStorage.timeLogout="5";
    timeLogoutNotification(message, des)
  } else if (nowTime - time >= 600000 && nowTime - time < 840000 && localStorage.timeLogout !=="10") {
    //10分钟
    const spareTime = _.get(permission, 'automaticLogoutTime') - 10;
    const message = t('unusedMessage', {time: 10});
    const des = t('unusedDescription', {unusedTime: 10, spareTime});
    localStorage.timeLogout="10";
    timeLogoutNotification(message, des)
  } else if (nowTime - time >= 840000 && localStorage.timeLogout!=="14") {
    //14分钟
    const spareTime = _.get(permission, 'automaticLogoutTime') - 14;
    const message = t('unusedMessage', {time: 14});
    const des = t('unusedDescription', {unusedTime: 14, spareTime});
    localStorage.timeLogout="14";
    timeLogoutNotification(message, des)
  }
  const automaticLogoutTime = _.get(permission, 'automaticLogoutTime')*60*1000;
  if (nowTime - time >= automaticLogoutTime) {
    delete localStorage.time;
    clearInterval(logoutTime)
    //退出账号提醒
    Modal.warning({
      title: t('autoLogoutTitle'),
      okText: t('commonConfirm'),
      content: (
        <div>
          <p>{t('autoLogoutContent')}</p>
        </div>
      ),
      onOk() {
        localStorage.clear();
        location.replace('/login.html');
      },
    });
  }
}

//socket emit
const emitSocket = () => {
  socket.emit('clientID', `${clientId}-Login-${id}`, 'success')
  if (_.get(permission, 'concurrentLogin.isEnabled')) {
    let socketRoom = `${clientId}-Login-${group_id}`;
    if (!_.isEmpty(_.get(permission, 'concurrentLogin.otherRoleIds'))) {
      socketRoom = `${clientId}-Login-${group_id}-${_.join(_.get(permission, 'concurrentLogin.otherRoleIds'), '-')}`
    }
    socket.emit('clientID', socketRoom, 'success')
  }
}

const render = function() {
  const { Component: App } = require('modules/app');
  emitSocket();
  //定时器——一秒触发一次
  if (_.get(permission, 'automaticLogoutTime')) {
    logoutTime = setInterval(() => {autoLogoutTime()}, 1000);
  } else {
    clearInterval(logoutTime)
  }

  ReactDOM.render(
    <Provider store={store}>
      <App history={history}/>
    </Provider>
  ,
    document.getElementById('app')
  );
}

const i18n = function() {
  const {default: translation} = require('i18n/translation');
  i18next.init({
    lng: "hk",
    resources: translation("hk"),
  }, (err, t) => {
    window.t = t;
    render();
  });
}

i18n();

if (process.env.NODE_ENV === 'production') {
  window.addEventListener('error', function(event) {
    if (event.error) {
      logFatal({
        message: event.error.message,
        stack: event.error.stack,
        url: location.href,
      });
    }
  });
}
if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept(['modules/app', 'i18n/translation'], function() {
    const {reducer: nextReducer} = require('modules/app');
    store.replaceReducer(nextReducer);
    i18n();
  });
}



/** WEBPACK FOOTER **
 ** ./src/app/app.js
 **/